package one.healthium.ui.compose.modifier

import androidx.compose.foundation.layout.widthIn
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import one.healthium.ui.compose.components.adaptive.AppAdaptiveDefaults

fun Modifier.adaptiveWidthTwoPane(): Modifier = composed {
    widthIn(max = AppAdaptiveDefaults.maxWidthTwoPaneMode)
}
